<template>
    <div v-if="afdelingen.length != 0" class="wrapper">
        <item-form
            :model="model"
            :afdelingen="afdelingen"
            :teelten="teelten"
            :isEditing="false"
            @save-item="addItem">
        </item-form>

        <b-modal title="Toevoegen" size="sm" class="modal-danger" v-model="warningModal" @ok="closedialog">
            FOUT: Teelt werd niet toegevoegd! {{errormsg}}
        </b-modal>
    </div>
</template>

<script>
    import api from '../../api/afdelingteelt';
    import ItemForm from './Form';

    export default {
        data () {
            return {
                warningModal: false,
                errormsg: '',
                afdelingen: [],
                teelten: [],
                model: {
                    aantalDagenVerleden: 0,
                    aantalDagenToekomst: 0,
                    percentageVerleden: 0,
                    percentageToekomst: 0,
                    aantalBelichtingen: 0,
                    dmins: [],
                    dplus: [],
                    belichtingsuren_n: [],
                },
            };
        },
        created () {
            api.getDetailAfdelingteelt(0).then((response) => {
                this.afdelingen = response.data.afdelingen;
                this.teelten = response.data.teelten;
            });
        },
        methods: {
            addItem (model) {
                api.addAfdelingteelt(model).then(() => {
                    this.$router.replace('/beheer/afdelingteelt');
                },
                (error) => {
                    this.errormsg = error.message;
                    this.warningModal = true;
                });
            },
            closedialog () {
                this.warningModal = false;
            },
        },
        components: {
            'item-form': ItemForm,
        },
    };
</script>



// WEBPACK FOOTER //
// src/pages/afdelingteelt/New.vue